module.exports = __webpack_public_path__ + "static/img/company_news06.aed488b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutMe/company_news06.jpg
// module id = YZT4
// module chunks = 2